import { NgClass, TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { IconType } from '@kinomap-dev/ng-ui-lib/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { Tooltip } from '../../directives/tooltip.directive';
import { ColorService } from '../../services/color.service';
import { FoldState } from '../../types/fold-state.type';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';

type SideMenuItem = {
  name: string;
  icon: IconType;
};

type SideMenuCategory = {
  name: string;
  items: SideMenuItem[];
};

const manageCategory: SideMenuCategory = {
  name: 'manage',
  items: [
    { name: 'dashboard', icon: 'dashboard' },
    { name: 'upload_history', icon: 'upload' },
    { name: 'contents', icon: 'agenda' },
    // { name: 'audiences', icon: 'audiences' },
    // { name: 'comments', icon: 'comment' },
  ],
};

const othersCategory: SideMenuCategory = {
  name: 'others',
  items: [
    { name: 'settings', icon: 'settings_stroke' },
    // { name: 'contact', icon: 'mail' },
  ],
};

@Component({
  selector: 'app-side-menu',
  imports: [
    IconComponent,
    Tooltip,
    NgClass,
    TranslateModule,
    UpperFirstLetterPipe,
    TitleCasePipe,
    RouterLink,
  ],
  templateUrl: './side-menu.html',
  styleUrl: './side-menu.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenu {
  public router: Router = inject(Router);
  private colorService: ColorService = inject(ColorService);

  menuCategories: SideMenuCategory[] = [manageCategory, othersCategory];
  hoveredItem: string | null = null;
  state: WritableSignal<FoldState> = signal('unfold');

  toggleState(): void {
    if (this.state() === 'fold') {
      this.state.update((state: FoldState) => (state = 'unfold'));
      return;
    }
    this.state.update((state: FoldState) => (state = 'fold'));
  }

  getIconColor(itemName: string): string {
    return this.hoveredItem === itemName || this.isActive(itemName)
      ? this.colorService.textColor()
      : this.colorService.neutral600();
  }

  setHoveredItem(itemName: SideMenuItem['name'] | null): void {
    this.hoveredItem = itemName;
  }

  isActive(itemName: SideMenuItem['name']): boolean {
    const routeName: string = this.router.url.split('/')[1];
    return itemName === routeName;
  }

  get contentCreationAvaible(): boolean {
    const currentUrl: string = this.router.url.split('/')[1];
    const restrictedUrl: string[] = ['content-creation'];
    return restrictedUrl.includes(currentUrl);
  }
}
